import type { HTMLAttributes } from 'react';

import { Typography } from '@remarkable/ark-web';

import { Label } from 'src/components';

export const TextWithLabel = ({
  label,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement> & { label: string }) => {
  return (
    <div {...props}>
      <Label className="whitespace-nowrap">{label}</Label>
      <Typography
        aria-label={label}
        variant="body-md"
        fontWeight="semibold"
        className="my-0 whitespace-nowrap"
        data-cy="value"
      >
        {children}
      </Typography>
    </div>
  );
};
